export default {
  INIT_SHOP_INFO: 'INIT_SHOP_INFO',
};



// WEBPACK FOOTER //
// ./src/consts/dish-menu-action-type.js